import {Link, LinkProps} from 'react-router-dom';
import clsx from 'clsx';
import React, {useMemo} from 'react';
import {slugifyString} from '@ui/utils/string/slugify-string';
import {CompactUser, User} from '@ui/types/user';
import {isIOSOrAndroid} from '@common/core/platform-detection';
import {StackTrigger} from '@ui/overlays/stack-navigator/stack-trigger';
import {UserProfilePage} from '@app/web-player/user-profile/user-profile-page';

interface UserProfileLinkProps extends Omit<LinkProps, 'to'> {
  user: User;
  className?: string;
}
export function UserProfileLink({
  user,
  className,
  ...linkProps
}: UserProfileLinkProps) {
  const finalUri = useMemo(() => {
    return getUserProfileLink(user);
  }, [user]);

  if (!isIOSOrAndroid()) {
    return (
      <Link
        {...linkProps}
        className={clsx('hover:underline', className)}
        to={finalUri}
      >
        {user.name}
      </Link>
    );
  }

  return (
    <StackTrigger moveFocusToDialog={false} title={user.name}>
      <div className={clsx('hover:underline', className)}>{user.name}</div>
      <UserProfilePage userId={user.id} />
    </StackTrigger>
  );
}

export function getUserProfileLink(user: CompactUser): string {
  return `/user/${user.id}/${slugifyString(user.name)}`;
}
